import { render } from "./size-guide.vue?vue&type=template&id=d6d2c896"
import script from "./size-guide.vue?vue&type=script&lang=js"
export * from "./size-guide.vue?vue&type=script&lang=js"

import "./size-guide.vue?vue&type=style&index=0&id=d6d2c896&lang=scss"

import exportComponent from "/buddy/derek-lam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__